<div class="main-header">
    <div class="logo">
        <img src="./assets/images/logo-imperial.png" alt="">
    </div>

    <div class="menu-toggle" (click)="toggleSidebar()">
        <div></div>
        <div></div>
        <div></div>
    </div>

    <div style="margin: auto"></div>

    <div class="header-part-right">
        <!-- Search button -->
        <!--        <i class="i-Magnifi-Glass1 header-icon" role="button" (click)="openSearch()"></i>-->

        <!-- Notification button - Hide for ROLE_USER -->
        <div ngbDropdown class="d-inline-block" (openChange)="onNotificationsOpen($event)" *ngIf="!isUserRole">
            <div class="notification-trigger" ngbDropdownToggle role="button">
                <i class="i-Bell header-icon" [ngClass]="{'text-danger': unreadCount > 0}"></i>
                <span class="notification-dot" *ngIf="unreadCount > 0"></span>
            </div>
            <div ngbDropdownMenu class="notification-dropdown dropdown-menu-right">
                <div class="dropdown-header d-flex justify-content-between align-items-center px-3 py-2">
                    <span><i class="i-Bell1 mr-1"></i> Njoftimet</span>
                    <span class="badge badge-pill badge-primary" *ngIf="unreadCount > 0">{{ unreadCount }}
                        të palexuara</span>
                </div>
                <div class="dropdown-divider m-0"></div>
                <ng-container *ngIf="loadingNotifications">
                    <div class="dropdown-item text-center">
                        <span class="spinner-border spinner-border-sm mr-2"></span> Duke u ngarkuar...
                    </div>
                </ng-container>
                <ng-container *ngIf="!loadingNotifications && !notifications.length">
                    <div class="dropdown-item text-center text-muted">
                        Nuk ka njoftime
                    </div>
                </ng-container>
                <ng-container *ngIf="!loadingNotifications && notifications.length">
                    <div class="dropdown-item d-flex" *ngFor="let notification of notifications">
                        <div class="notification-icon">
                            <i [class]="getNotificationIcon(notification.type)"></i>
                        </div>
                        <div class="notification-details flex-grow-1">
                            <p class="m-0 d-flex align-items-center">
                                <span>{{ notification.productName || 'Njoftim' }}</span>
                                <span class="badge badge-pill badge-danger ml-2" *ngIf="!notification.isRead">e re</span>
                                <span class="flex-grow-1"></span>
                                <span class="text-small text-muted ml-auto">{{ formatNotificationTime(notification.createdAt) }}</span>
                            </p>
                            <p class="text-small text-muted m-0"
                               (click)="navigateToNotifications($event)">{{ notification.message }}</p>
                        </div>
                    </div>
                </ng-container>
                <div class="dropdown-divider m-0"></div>
                <div class="dropdown-item text-center">
                    <a href="" class="btn btn-link btn-sm" (click)="navigateToNotifications($event)">Shiko të gjitha
                        njoftimet</a>
                </div>
            </div>
        </div>

        <!-- User profile dropdown -->
        <div ngbDropdown class="d-inline-block">
            <img src="./assets/images/faces/1.jpg" id="userDropdown" alt=""
                 ngbDropdownToggle [ngClass]="{'cursor-pointer': true}">
            <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="userDropdown">
                <div class="dropdown-header">
                    <i class="i-Lock-User me-1"></i> {{ username }}
                </div>
                <!--                <a class="dropdown-item">Account settings</a>-->
                <!--                <a class="dropdown-item">Billing history</a>-->
                <a class="dropdown-item" (click)="signOut()" style="cursor: pointer;"><i class="i-Arrow-Right-2"></i>Sign
                    out</a>
            </div>
        </div>
    </div>
</div>
